import type { IconConcept } from '@workflow/ui'

export interface SettingsSection {
  id: string
  name: string
  icon: IconConcept
}

export interface SettingsGroup {
  title: string
  sections: readonly SettingsSection[]
}

/**
 * Settings grows as the platform does. The tree reads in groups — Personal,
 * then whatever the platform gains — so a growing list stays scannable. The
 * Studio group is the platform's own machinery; its sections decide for
 * themselves what a non-administrator sees.
 */
export const SETTINGS_GROUPS: readonly SettingsGroup[] = [
  {
    title: 'Personal',
    sections: [
      { id: 'account', name: 'Account', icon: 'user' },
      { id: 'appearance', name: 'Appearance', icon: 'appearance' },
    ],
  },
  {
    title: 'Studio',
    sections: [
      { id: 'work-types', name: 'Categories', icon: 'tasks' },
      { id: 'runtimes', name: 'Runtimes', icon: 'instance' },
      { id: 'api', name: 'API', icon: 'key' },
    ],
  },
]

/** The groups a role sees: a player keeps Personal; the Studio group is the studio's. */
export function settingsGroupsFor(role: string | undefined): readonly SettingsGroup[] {
  return role === 'player' ? SETTINGS_GROUPS.filter((group) => group.title === 'Personal') : SETTINGS_GROUPS
}

/** Every section, flattened — the page's own lookup. */
export const SETTINGS_SECTIONS: readonly SettingsSection[] = SETTINGS_GROUPS.flatMap((group) => [...group.sections])
